import request, { IWorkspaceResponse } from '/@/api/http/request'
import { ELocalStorageKey } from '/@/types'
import { NightLightsStateEnum, DistanceLimitStatus, ObstacleAvoidance } from '/@/types/device-setting'

const MNG_API_PREFIX = '/manage/api/v1'
const workspaceId: string = localStorage.getItem(ELocalStorageKey.WorkspaceId) || ''

export interface ThermalCurrentPaletteStyleParam {
  payload_index:string
  thermal_current_palette_style:number
}
export interface PutDevicePropsBody {
  night_lights_state?: NightLightsStateEnum;// 夜航灯开关
  height_limit?: number;// 限高设置
  distance_limit_status?: DistanceLimitStatus;// 限远开关
  obstacle_avoidance?: ObstacleAvoidance;// 飞行器避障开关设置
  thermal_current_palette_style?: ThermalCurrentPaletteStyleParam; // 热成像当前调色板样式
}

export interface SettingQueryParam {
  user_name: string
  device_sn: string
  workspace_id: string
  status: string
}

export interface SettingPageRequest {
  page: number
  page_size: number
  param: SettingQueryParam
}

/**
 * 设置设备属性
 * @param params
 * @returns
 */
//  /manage/api/v1/devices/{{workspace_id}}/devices/{{device_sn}}/property
export async function putDeviceProps (deviceSn: string, body: PutDevicePropsBody): Promise<IWorkspaceResponse<{}>> {
  const resp = await request.put(`${MNG_API_PREFIX}/devices/${workspaceId}/devices/${deviceSn}/property`, body)
  return resp.data
}

/**
 * 获取设备授权列表
 */
export async function userDeviceRelationPage (body:SettingPageRequest): Promise<IWorkspaceResponse<{}>> {
  const url = `${MNG_API_PREFIX}/user-device-relation/page`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 删除用户设备关系
 */
export async function delectUserDeviceRelation (id : string): Promise<IWorkspaceResponse<{}>> {
  const url = `${MNG_API_PREFIX}/user-device-relation/delete-user-device-by-id/${id}`
  const result = await request.delete(url)
  return result.data
}

/**
 * 保存用户设备关系
 */
export async function saveOrUpdateUserDeviceRelation (body : any) : Promise<IWorkspaceResponse<{}>> {
  const url = `${MNG_API_PREFIX}/user-device-relation/save-or-update-user-device`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 获取设备授权列表
 */
export async function userDeviceRelationList (body:any): Promise<IWorkspaceResponse<{}>> {
  const url = `${MNG_API_PREFIX}/user-device-relation/get-user-device`
  const result = await request.post(url, body)
  return result.data
}

/**
 * 获取设备关联空间
 */
export async function userDeviceRelationWorkspaceList (deviceSn:string): Promise<IWorkspaceResponse<{}>> {
  const url = `${MNG_API_PREFIX}/user-device-relation/get-user-device-workspace/${deviceSn}`
  const result = await request.get(url)
  return result.data
}
